import React, { useContext } from 'react';
import { Tooltip } from 'primereact/tooltip';
import { TLLandingContext } from '../../features/landingPage/teamLeadLandingPage/TeamLeadLandingPage';

interface ScorecardStepperProps {
    step: any;
    isEndStep: boolean;
    activeStep?: number;
}
export const ScorecardStepper = ({ step, isEndStep, activeStep }: ScorecardStepperProps) => {
    const { viaPage } = useContext(TLLandingContext);
    const activeBarColor = step.inProcess ? '#CECECD' : step.colorCode;
    const StepperStepsTooltips = [
        {
            id: 1,
            stalled: {
                false: 'No Action Needed.',
                true: 'Your EDS is verifying the data. Please be patient.',
            },
        },
        {
            id: 2,
            stalled: {
                false: 'Please clear disputes, review metrics and approve your payout!',
                true: 'Empower is waiting for at least 75% of your colleagues to review and approve!',
            },
        },
        {
            id: 3,
            stalled: {
                false: 'Team Leads are actively reviewing the team’s metrics and approving payouts!',
                true: 'Empower is waiting for at least 75% of (Agents + Team Leads) to submit their approvals.',
            },
        },
        {
            id: 4,
            stalled: {
                false: 'Managers are working on approving 100% of the payouts.',
                true: 'Please be patient, the managers are working to verify and approve 100% of the payouts.',
            },
        },
        {
            id: 5,
            stalled: {
                false: 'The Compensation Team is performing final payout checks.',
                true: 'The Compensation Team is performing final payout checks',
            },
        },
        {
            id: 6,
            stalled: {
                false: 'Payouts are ready for extract by the compensation team.',
                true: 'Payouts are ready for extract by the compensation team.',
            },
        },
        {
            id: 7,
            stalled: {
                false: 'Payouts have been submitted to payroll.',
                true: 'Payouts have been submitted to payroll.',
            },
        },
        {
            id: 8,
            stalled: {
                false: 'The Scorecard will be recalculated. If your payout changes, you will be asked to re-approve your payout.',
                true: 'The Scorecard will be recalculated. If your payout changes, you will be asked to re-approve your payout.',
            },
        },
    ];
    const getTooltip = (id: number, stalled: boolean): string => {
        const step = StepperStepsTooltips.find((step) => step.id === id);
        if (step && id === activeStep) {
            return stalled ? step?.stalled?.true : step?.stalled?.false;
        }
        return '';
    };
    const renderIconOrPct = () => {
        if (step.pct > 0) {
            return <span style={{ fontSize: '12px' }}>{step.pct}%</span>;
        } else {
            return step.icon?.length > 0 ? (
                <img src={step.icon} alt="icon" style={{ width: '18px', height: '18px' }} />
            ) : (
                ''
            );
        }
    };
    return (
        <div>
            <p
                className={`${'tooltip'}${step.stepId}`}
                style={{
                    display: 'flex',
                    fontSize: '14px',
                    alignItems: 'center',
                    maxWidth: '105px',
                    minHeight: '45px',
                    color: `${step.colorCode}`,
                }}
            >
                {step.stepName}
            </p>
            <Tooltip
                mouseTrack
                mouseTrackLeft={10}
                target={`${'.tooltip'}${activeStep}`}
                content={getTooltip(step.stepId, step.isStalled)}
                style={{ fontSize: '14px' }}
            />
            <div style={{ display: 'flex' }}>
                <div style={{ display: 'flex', flexDirection: 'column' }}>
                    <div
                        className={`${'tooltip'}${step.stepId}`}
                        style={{
                            display: 'flex',
                            alignItems: 'center',
                            justifyContent: 'center',
                            width: '36px',
                            height: '36px',
                            background: `${step.colorCode}`,
                            borderRadius: '50%',
                            color: '#FFF',
                        }}
                    >
                        {renderIconOrPct()}
                    </div>
                </div>
                {!isEndStep && (
                    <div style={{ display: 'flex', alignItems: 'center' }}>
                        <span
                            style={{
                                width: viaPage === 'TLLandingPage' ? '55px' : '76px',
                                height: '3px',
                                borderRadius: '10px',
                                background: `${activeBarColor}`,
                                margin: '0px 5px',
                            }}
                        />
                    </div>
                )}
            </div>
            <p
                style={{
                    display: 'flex',
                    fontSize: '14px',
                    alignItems: 'center',
                    maxWidth: '105px',
                    minHeight: '45px',
                    color: `${step.colorCode}`,
                }}
            >
                {step.subHeading}
            </p>
        </div>
    );
};
